import drawingRender from '../components/interactions/drawingRender.vue';

export class DrawingInteraction {
  constructor(question, testData) {
    this.question = question;
    this.testData = testData;
    this.userAnswer = {
      drawingData: null,
      textBlockContent: '',
      textBlockPosition: 'bottom',
      timestamp: null
    };
  }

  /**
   * Render method to return the Vue component
   */
  render() {
    return {
      component: drawingRender,
      props: {
        question: this.question,
        testData: this.testData,
        restoredAnswer: this.userAnswer,
      },
    };
  }

  restoreAnswer(savedAnswer) {
    if (savedAnswer) {
      this.userAnswer = {
        drawingData: savedAnswer.drawingData || null,
        textBlockContent: savedAnswer.textBlockContent || '',
        textBlockPosition: savedAnswer.textBlockPosition || 'bottom',
        timestamp: savedAnswer.timestamp || null
      };
    }
  }

  calculateScore(userAnswer) {
    // Drawing interactions typically require manual correction
    // Return 0 as placeholder - actual scoring happens in corrector platform
    return 0;
  }

  saveAnswer() {
    return this.userAnswer;
  }

  isAnswerComplete(userAnswer) {
    if (!userAnswer || !userAnswer.drawingData) {
      return false;
    }
    return true;
  }
}

export default DrawingInteraction;
